import axios from "axios";
import axiosUrl from "./axios.service";
import store from "../store/index";
import router from "../router";
import UserService from "./userprofile.service";
import { computed } from "vue";
import ETagType from "../enums/ETagType";

const API_URL = axiosUrl.getAxiosUrl();
const isVind = computed({
  get: () => store.state.auth.env === 0 || store.state.auth.env === 40,
});
const env = computed({
  get: () => store.state.auth.env,
});

class UserProfileService {
  async getHiddenSchemes() {
    return await axios
      .get(API_URL + "/scheme/getHiddenSchemes")
      .then((response) => {
        if (response.status === 200) {
          store.commit("user/fillHiddenSchemesList", response.data);
        }
      });
  }

  async getFolders() {
    return await axios.get(API_URL + "/users/getFolders").then((response) => {
      if (response.status === 200) {
        store.commit("user/fillFolders", response.data);
      }
    });
  }

  async getFolderItems(folderId) {
    return await axios
      .get(API_URL + "/users/getFolder", {
        params: {
          folderId: folderId,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          store.commit("user/fillFolderItems", response.data);
        }
      });
  }

  async getFolderSchemeItem(folderId, schemeId) {
    return await axios
      .get(API_URL + "/users/getFolderSchemeItem", {
        params: {
          folderId: folderId,
          schemeId: schemeId,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          store.commit("user/fillFolderSchemeItem", response.data);
        }
      });
  }

  async saveSchemes(folderWithoutItems, selectedResults, locale) {
    return axios
      .post(
        API_URL + "/users/saveFolderItems",
        {
          id:
            folderWithoutItems.folder != null
              ? folderWithoutItems.folder.id
              : null,
          name: folderWithoutItems.newFolderName,
          folderItems: selectedResults,
        },
        {
          params: {
            culture: locale ? locale.value : null,
          },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          store.commit("user/disableSaveScheme");
          store.commit("user/enableShowSavedInfoDialog", response.data);
          store.commit("user/disableSavePortalsScheme");
          // router.push({ name: 'UserProfile', params: { tab: 'savedItems' } });
        }
      })
      .catch((error) => {
        if (error)
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
      });
  }

  async addNewFolder(newFolderName, locale) {
    return axios
      .post(
        API_URL + "/users/createFolder",
        {
          name: newFolderName,
        },
        {
          params: {
            culture: locale.value,
          },
        }
      )
      .catch((error) => {
        if (error)
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
      });
  }

  async removeSavedScheme(itemId) {
    return axios({
      method: "post",
      url: API_URL + "/users/deleteFolderItem",
      params: {
        folderItemId: itemId,
      },
    }).catch((error) => {
      if (error)
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
    });
  }

  async updateFolderItemAlert(itemId, hasAlert) {
    return axios({
      method: "post",
      url: API_URL + "/users/updateAlert",
      params: {
        hasAlert: hasAlert,
        folderItemId: itemId,
      },
    }).catch((error) => {
      if (error)
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
    });
  }

  async updateFolderItemsAlert(itemsIds, hasAlert) {
    return axios
      .post(API_URL + "/users/updateAlerts", {
        hasAlert: hasAlert,
        folderItemsIds: itemsIds,
      })
      .catch((error) => {
        if (error)
          store.commit("scheme/updateModalError", error.response.data),
            store.commit("scheme/enableModalError");
      });
  }

  async getUser(locale) {
    return await axios
      .get(API_URL + "/users/getUser", {
        params: {
          culture: locale.value,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          store.commit("user/fillUserObject", response.data);
          if (!isVind.value) {
            if (
              response.data.person.portalOrganisation != "" &&
              response.data.themeType > 0 &&
              response.data.searchInterest > 0 &&
              response.data.searchInterest != 6
            ) {
              store.commit("user/updateIsProfileComplited", true);
            }
            if (response.data.searchInterest == 6) {
              store.commit("user/updateIsProfileComplited", true);
            }
            if (
              response.data.person.portalOrganisation == "" &&
              response.data.themeType == 0 &&
              response.data.searchInterest == 0
            ) {
              store.commit("user/updateIsProfileComplited", false);
            }
            if (env.value == 30) {
              if (response.data.professionType == 0) {
                store.commit("user/updateIsProfessionSelected", false);
              } else store.commit("user/updateIsProfessionSelected", true);
            }
          }
        }
      });
  }

  async getCustomerByUser(locale) {
    return await axios
      .get(API_URL + "/users/getCustomerByUser", {
        params: {
          culture: locale.value,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          store.commit("user/fillCustomerObject", response.data);
        }
      });
  }

  async getFavoriteAudienceTags(locale) {
    return await axios
      .get(API_URL + "/Tags/GetFavoriteTags", {
        params: {
          culture: locale.value,
          tagType: ETagType.Audience,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          store.commit("user/updateFavoriteAudiencesIdsArray", response.data);
        }
      });
  }

  // not in use?
  async getAllCustomers() {
    return await axios
      .get(API_URL + "/users/getAllCustomers", {})
      .then((response) => {
        if (response.status === 200) {
          store.commit("obExport/updateCustomersList", response.data);
        }
      });
  }

  async getOnzeCustomers() {
    return await axios
      .get(API_URL + "/salesforce/getOnzeCustomers", {})
      .then((response) => {
        if (response.status === 200) {
          store.commit("obExport/updateOnzeCustomers", response.data);
        }
      });
  }

  async getFavoritePurposesTags(locale) {
    return await axios
      .get(API_URL + "/Tags/GetFavoriteTags", {
        params: {
          culture: locale.value,
          tagType: ETagType.Purposes,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          store.commit("user/updateFavoritePurposesIdsArray", response.data);
        }
      });
  }
  //This is just hidden for now, don't remove it:
  /*
  async getFavoriteIndustriesTags() {
    return await axios
      .get(API_URL + '/Tags/GetFavoriteTags', {
        params: {
          tagType: ETagType.Industries
        }
      })
      .then((response) => {
        if (response.status === 200) {
          store.commit('user/updateFavoriteIndustriesIdsArray', response.data);
        }
      });
  }
*/
  async getFavoriteLocationsTags(locale) {
    return await axios
      .get(API_URL + "/Tags/GetFavoriteLocationsTags", {
        params: {
          culture: locale.value,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          store.commit("user/updateSelectedFavoriteLocations", response.data);
        }
      });
  }
  //check for authUSer
  async getNewsletterFrequency() {
    return await axios
      .get(API_URL + "/users/getFrequencyType")
      .then((response) => {
        if (response.status === 200) {
          store.commit("user/updateNewsletterFrequencyType", response.data);
        }
      });
  }

  async getProfileConfiguration() {
    return await axios
      .get(API_URL + "/users/getProfileConfiguration")
      .then((response) => {
        if (response.status === 200) {
          store.commit(
            "user/updateSchemeChangesInNewsletterStatus",
            response.data.schemeChangesInNewsletter
          );
          store.commit(
            "user/updateOpenDetailsInNewTab",
            response.data.openDetailsInNewTab
          );
          store.commit(
            "user/updateHideHiddenItemsDialog",
            response.data.hideHiddenItemsDialog
          );
          store.commit(
            "user/setIsApplyingFilters",
            response.data.isApplyFilter
          );
          store.commit(
            "user/updateIsInformedAboutNews",
            response.data.isInformedAboutNews
          );
          store.commit("user/updateThemeType", response.data.themeType);
          store.commit(
            "user/updateSearchInterest",
            response.data.searchInterest
          );
        }
      });
  }

  async loadFilter(searchId) {
    return await axios
      .get(API_URL + "/search/loadSearch", {
        params: {
          id: searchId,
          isSchemesSearch: true,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // ugasi apply filters (store.commit i na backend da ode)
          // resetuj sve filtere (store.commmit tako ici)

          store.commit("user/setIsApplyingFilters", false);
          store.commit("advancedSearch/resetSearchFilter", false);
          store.commit("user/setIsProfileSearch", true);
          store.commit(
            "advancedSearch/fillFiltersWithSavedValues",
            response.data
          );
          store.commit("user/fillFiltersWithSavedValues", response.data);
          store.commit(
            "advancedFilters/fillFiltersWithSavedValues",
            response.data
          );
          router.push({ name: "SearchGrants" });
        }
      });
  }

  async editUser(user) {
    return axios
      .post(API_URL + "/users/edit", {
        username: user.username.value,
        email: user.email.value,
        person: {
          firstName: user.firstName.value,
          lastName: user.lastName.value,
          portalOrganisation: user.portalOrganisation.value,
          salutation: user.salutation.value,
        },
      })
      .then((response) => {
        store.commit("user/fillUserObject", response.data);
        // router.go();
      })
      .catch((error) => {
        if (error)
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
      });
  }

  async editUserPortalOrganisation(portalOrganisation) {
    return axios
      .post(API_URL + "/users/editUserPortalOrganisation", {
        person: {
          portalOrganisation: portalOrganisation,
        },
      })
      .then((response) => {
        store.commit(
          "user/updatePortalOrganisation",
          response.data.person.portalOrganisation
        );
        // router.go();
      })
      .catch((error) => {
        if (error)
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
      });
  }

  async setFavoriteTags(favoriteTags, type, locale) {
    return axios
      .post(
        API_URL + "/Tags/SetFavoriteTags",
        {
          tags: favoriteTags,
          type: type,
        },
        {
          params: {
            culture: locale.value,
          },
        }
      )
      .catch((error) => {
        if (error)
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
      });
  }

  async setNewsletterFrequency(frequency) {
    return axios
      .post(API_URL + "/users/setNewsletterFrequency", {
        frequencyType: frequency,
      })
      .then((response) => {
        if (response.status == 200) {
          UserService.getNewsletterFrequency();
          store.commit("user/enableConfirmation");
        }
      })
      .catch((error) => {
        if (error)
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
      });
  }

  async setSchemeChangesInNewsletterStatus(status) {
    return axios
      .post(API_URL + "/users/setSchemeChangesInNewsletter", {
        schemeChangesInNewsletter: status,
      })
      .then((response) => {
        if (response.status == 200) {
          UserService.getProfileConfiguration();
        }
      })
      .catch((error) => {
        if (error)
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
      });
  }

  async setOpenDetailsInNewTab(status) {
    return axios
      .post(API_URL + "/users/setOpenDetailsInNewTab", {
        openDetailsInNewTab: status,
      })
      .then((response) => {
        if (response.status == 200) {
          UserService.getProfileConfiguration();
        }
      })
      .catch((error) => {
        if (error)
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
      });
  }

  async setHideHiddenItemsDialog(value) {
    return axios
      .post(API_URL + "/users/setHideHiddenItemsDialog", {
        hideHiddenItemsDialog: value,
      })
      .then((response) => {
        if (response.status == 200) {
          UserService.getProfileConfiguration();
        }
      })
      .catch((error) => {
        if (error)
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
      });
  }

  async setApplyFilter(isApply) {
    return axios
      .post(API_URL + "/users/setApplyFilters", {
        IsApplyFilter: isApply,
      })
      .catch((error) => {
        if (error)
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
      });
  }

  async requestResetPassword(username, selectedSasCustomer) {
    return axios
      .post(API_URL + "/users/requestResetPassword", {
        username: username.value,
        sasCustomerId: selectedSasCustomer.value,
      })
      .then(() => {})
      .catch((error) => {
        if (error)
          store.commit("auth/updateModalError", error.response.data),
            store.commit("auth/enableModalError");
      });
  }

  async setNewPassword(password, confirmationPassword, token, locale) {
    return axios
      .post(
        API_URL + "/users/setNewPassword",
        {
          newPassword: password.value,
          confirmPassword: confirmationPassword.value,
          token: token.value,
        },
        {
          params: {
            culture: locale.value,
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          return true;
        } else {
          store.commit("user/updateModalError", res.data.message),
            store.commit("user/enableModalError");
          return false;
        }
      })
      .catch((error) => {
        if (error)
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
      });
  }

  async checkIsValidLink(token) {
    return axios
      .get(API_URL + "/users/expirationToken", {
        params: {
          passwordToken: token.value,
        },
      })
      .then((response) => {
        store.commit("user/setIsLinkValid", response.data);
      });
  }
  async updateCustomerName(customer) {
    return axios
      .post(API_URL + "/users/updateCustomerName", {
        id: customer.id.value,
        name: customer.name.value,
      })
      .then((response) => {
        store.commit("user/fillCustomerObject", response.data);
      })
      .catch((error) => {
        if (error)
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
      });
  }

  async getAllSalutations() {
    return await axios
      .get(API_URL + "/users/getAllSalutations")
      .then((response) => {
        store.commit("user/updateSalutationsList", response.data);
      })
      .catch((error) => {
        if (error)
          store.commit("user/updateModalError", error),
            store.commit("user/enableModalError");
      });
  }

  async getNewsletterFrequencyTypes() {
    return await axios
      .get(API_URL + "/users/getNewsletterFrequencyTypes")
      .then((response) => {
        store.commit("user/updateNewsletterFrequencyTypes", response.data);
      })
      .catch((error) => {
        if (error)
          store.commit("user/updateModalError", error),
            store.commit("user/enableModalError");
      });
  }

  async checkIfSoftDeletedUserExists(email, customerId) {
    return await axios
      .get(API_URL + "/users/checkIfSoftDeletedUserExists", {
        params: {
          email: email,
          customerId: customerId,
        },
      })
      .then((response) => {
        store.commit(
          "user/updateShowReactivateSoftDeletedUserModal",
          response.data
        );
        return response;
      })
      .catch((error) => {
        if (error)
          store.commit("user/updateModalError", error),
            store.commit("user/enableModalError");
      });
  }

  async addNewUser(user, locale) {
    return await axios.post(
      API_URL + "/users/addNewUser",
      {
        // username should always be the same as email
        username: user.email,
        email: user.email,
        assignSasRole: user.assignSasRole,
        sasRoleId: user.sasRoleId,
        categoriesIds: user.categoriesIds,
        person: {
          firstName: user.person.firstName,
          lastName: user.person.lastName,
          salutation: user.person.salutation,
          startDate: user.person.startDate,
          sasStartDate: user.person.sasStartDate,
          customer: user.person.customer.name,
          customerId: user.person.customer.value,
          department: user.person.department,
          isAccountManager: user.person.isAccountManager,
          hasSasTaskEmails: user.person.receivesSasTaskEmails,
        },
      },
      {
        params: {
          culture: locale.value,
        },
      }
    );
  }

  async sendPasswordSetupMail(selectedUserId, locale) {
    return await axios
      .post(
        API_URL + "/users/sendPasswordSetupMail",
        {
          id: selectedUserId,
        },
        {
          params: {
            culture: locale.value,
          },
        }
      )
      .catch((error) => {
        if (error)
          store.commit("user/updateModalError", error),
            store.commit("user/enableModalError");
      });
  }

  async deactivateUser(selectedUserId, locale) {
    return await axios
      .post(
        API_URL + "/users/deactivateUser",
        {
          id: selectedUserId,
        },
        {
          params: {
            culture: locale.value,
          },
        }
      )
      .catch((error) => {
        if (error) {
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
        }
      });
  }
  async anonymizeUser(userId, locale) {
    return await axios
      .post(API_URL + "/users/anonymizeUser", {
        id: userId,
      })
      .catch((error) => {
        if (error) {
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
        }
      });
  }
  async reactivateUser(selectedUserId, locale) {
    return await axios
      .post(
        API_URL + "/users/reactivateUser",
        {
          id: selectedUserId,
        },
        {
          params: {
            culture: locale.value,
          },
        }
      )
      .catch((error) => {
        if (error) {
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
        }
      });
  }

  async resetMfaForUser(userId) {
    return await axios
      .post(API_URL + "/MFA/resetMfa", {
        id: userId,
      })
      .catch((error) => {
        store.commit("user/updateModalError", error.response.data);
        store.commit("user/enableModalError");
      });
  }

  async editFrontOfficeUser(user, locale) {
    return axios
      .post(
        API_URL + "/users/editUser",
        {
          id: user.id.value,
          username: user.email.value,
          email: user.email.value,
          contentRolesIds: user.selectedContentRolesIds.value,
          sasRolesIds: user.selectedSasRolesIds.value,
          person: {
            firstName: user.firstName.value,
            lastName: user.lastName.value,
            department: user.department.value,
            isAccountManager: user.isAccountManager.value,
            salutation: user.salutation.value,
            startDate: user.startDate.value,
            endDate: user.endDate.value,
            sasStartDate: user.sasStartDate.value,
            sasEndDate: user.sasEndDate.value,
            hasSasTaskEmails: user.hasSasTaskEmails.value,
          },
        },
        {
          params: {
            culture: locale.value,
          },
        }
      )
      .catch((error) => {
        if (error) {
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
        }
      });
  }

  async updateThemeType(themeType) {
    return await axios
      .post(API_URL + "/users/updateThemeType", {
        ThemeType: themeType,
      })
      .catch((error) => {
        if (error) {
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
        }
      });
  }
  async updateProfessionType(profession) {
    return await axios
      .post(API_URL + "/users/updateProfession", {
        professionType: profession,
      })
      .catch((error) => {
        if (error) {
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
        }
      });
  }
  async updateInformedAboutNews(isInformedAboutNews) {
    return await axios
      .post(API_URL + "/users/updateIsInformedAboutNews", {
        isInformedAboutNews: isInformedAboutNews,
      })
      .catch((error) => {
        if (error) {
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
        }
      });
  }
  async updateUnsubscriptionFromNewsReason(reasonForUnsubscribing) {
    return await axios
      .post(API_URL + "/users/updateUnsubscriptionFromNewsReason", {
        unsubscriptionNewsReason: reasonForUnsubscribing,
      })
      .catch((error) => {
        if (error) {
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
        }
      });
  }
  async updateSearchInterest(searchInterest) {
    return await axios
      .post(API_URL + "/users/updateSearchInterest", {
        searchInterest: searchInterest,
      })
      .catch((error) => {
        if (error) {
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
        }
      });
  }
  async getIndividualSchemeStatus() {
    return await axios
      .get(API_URL + "/users/getIndividualSchemeStatuses")
      .then((response) => {
        store.commit("user/setIndividualSchemeStatus", response.data);
      });
  }

  async updateIndividualStatus(id, individualSchemeStatus) {
    return await axios
      .post(API_URL + "/users/updateIndividualSchemeStatus", {
        folderItemId: id,
        individualStatus: individualSchemeStatus,
      })
      .catch((error) => {
        if (error) {
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
        }
      });
  }

  async renameFolder(folderName, folderId, locale) {
    return axios
      .post(
        API_URL + "/users/renameFolder",
        {
          id: folderId.value,
          name: folderName.value,
        },
        {
          params: {
            culture: locale.value,
          },
        }
      )
      .catch((error) => {
        if (error) {
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
        }
      });
  }

  async removeFolder(folderId) {
    return axios
      .post(API_URL + "/users/removeFolder", {
        id: folderId,
      })
      .catch((error) => {
        if (error) {
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
        }
      });
  }

  async completeOnboarding(id) {
    return axios
      .post(API_URL + "/users/completeOnboardingProcess", { userId: id })
      .then(() => {
        store.commit("auth/setAuthUserCompletedProfileSetup", true);
      })
      .catch((error) => {
        if (error)
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
      });
  }

  async getCustomerLanguageCodeForUser(id) {
    return axios
      .get(API_URL + "/users/getCustomerLanguageCodeForUser", {
        params: {
          id: id,
        },
      })
      .then((response) => {
        store.commit("user/updateCustomerLanguageCodeForUser", response.data);
      })
      .catch((error) => {
        if (error)
          store.commit("user/updateModalError", error),
            store.commit("user/enableModalError");
      });
  }

  async getContentRoles() {
    return await axios
      .get(API_URL + "/users/getContentRoles")
      .then((response) => {
        store.commit("user/setContentRoles", response.data);
      })
      .catch((error) => {
        if (error)
          store.commit("user/updateModalError", error),
            store.commit("user/enableModalError");
      });
  }
  async getSasRoles(showLowerLevelRolesOnly) {
    return await axios
      .get(API_URL + "/users/getSasRoles", {
        params: {
          showLowerLevelRolesOnly: showLowerLevelRolesOnly,
        },
      })
      .then((response) => {
        store.commit("user/setSasRoles", response.data);
      })
      .catch((error) => {
        if (error)
          store.commit("user/updateModalError", error),
            store.commit("user/enableModalError");
      });
  }

  async exportUsers() {
    return await axios.get(API_URL + "/users/exportUsers", {
      responseType: "blob",
    });
  }

  async getSasCategories() {
    return await axios
      .get(API_URL + "/users/getSasCategories")
      .then((response) => {
        store.commit("user/updateCategorizations", response.data.sasCategories);
      })
      .catch((error) => {
        if (error) store.commit("user/updateModalError", error);
        store.commit("user/enableModalError");
      });
  }
}

export default new UserProfileService();
